import React, { ReactElement } from "react";
import LoginInputView from "./LoginInputView";
import { ISignUpView } from "./types";

const SignUpView: React.FC<ISignUpView> = ({
  email,
  password,
  confirmPassword,
  handleChange,
  handleSubmit,
  isLoading,
}: ISignUpView): ReactElement => {
  return (
    <section className="bg-white">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <a
          href="#"
          className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-black"
        >
          Greenarc
        </a>
        <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-black">
              Sign up
            </h1>
            <form className="space-y-4 md:space-y-6" action="#">
              <LoginInputView
                handleChange={handleChange}
                type="email"
                id="email"
                value={email}
                label="Email"
                placeholder="name@company.com"
              />
              <LoginInputView
                handleChange={handleChange}
                type="password"
                id="password"
                value={password}
                label="Password"
                placeholder="***********"
              />
              <LoginInputView
                handleChange={handleChange}
                type="password"
                id="confirmpassword"
                value={confirmPassword}
                label="Password"
                placeholder="***********"
              />

              <div className="flex items-center justify-between">
                <div className="flex items-start">
                  <div className="flex items-center h-5">
                    <input
                      id="remember"
                      aria-describedby="remember"
                      type="checkbox"
                      className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                    />
                  </div>
                  <div className="ml-3 text-sm">
                    <label className="text-gray-500 dark:text-gray-300">
                      Remember me
                    </label>
                  </div>
                </div>
                <a
                  href="#"
                  className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500"
                >
                  Forgot password?
                </a>
              </div>
              {
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="w-full text-black border-black bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                >
                  Create account
                </button>
              }
              <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                Don’t have an account yet?{" "}
                <a
                  href="#"
                  className="font-medium text-primary-600 hover:underline dark:text-primary-500"
                ></a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignUpView;
